import React from 'react';
import { useTranslation } from 'react-i18next';

const WhyItMatters: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section
      id="why"
      className="py-5 py-md-5"
      aria-labelledby="why-headline"
    >
      <div className="container" style={{ maxWidth: 880 }}>
        <div
          className="glass-card"
          style={{
            // Signature: a single gold rule down the left edge marks this as
            // the page's thesis, not just another paragraph.
            borderLeft: '3px solid var(--accent-primary)',
            padding: 'clamp(1.5rem, 4vw, 2.75rem)',
          }}
        >
          <p
            className="mb-3"
            style={{
              fontFamily: 'var(--font-mono, monospace)',
              fontSize: '0.72rem',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'var(--accent-primary)',
            }}
          >
            {t('landing.why.eyebrow', { defaultValue: 'The thesis' })}
          </p>
          <h2
            id="why-headline"
            className="fw-semibold mb-4"
            style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--text-primary)',
              fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
              lineHeight: 1.15,
            }}
          >
            {t('landing.why.headline')}
          </h2>
          <p
            className="mb-0"
            style={{
              color: 'var(--text-secondary)',
              maxWidth: '62ch',
              fontSize: 'clamp(1.05rem, 1.6vw, 1.2rem)',
              lineHeight: 1.75,
            }}
          >
            {t('landing.why.body')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyItMatters;
